import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import functions from "../../redux/configs/functions";
import { RenderInput } from "./RenderInput";

export const BarcodeSuggestion = ({ props, cpn, page, apiData }) => {
  const { proxy, lang } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const {
    props: {
      idModal,
      source: { DisplayFields = [] },
    },
  } = cpn;

  const [isFetching, setIsFetching] = useState(true);
  const [data, setData] = useState([]);
  const [searchingData, setSearchingData] = useState({
    start_index: 0,
    criteria: {},
    require_count: false,
    require_statistic: false,
    isRegexSearching: {},
    sort: {},
  });

  useEffect(() => {
    const { url } = props.api;

    fetch(`${proxy()}${url}`, {
      method: "GET",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        const { data } = res;
        setData(data);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, []);

  console.log("BarcodeSuggestion", props, cpn);

  if (isFetching) {
    return (
      <img
        width={40}
        className="loading-image"
        src="/images/icon/load.gif"
        alt="Loading..."
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
        }}
      />
    );
  }

  return (
    <section
      className="table-display d-flex"
      style={{ minHeight: idModal ? "unset" : "78vh" }}
    >
      <section
        class="table-responsive table-custom design-table"
        style={{ height: idModal ? "62vh" : "80vh" }}
      >
        <Table>
          <thead>
            <tr>
              <td class="index">#</td>
              {DisplayFields?.map(({ id, label }, index) => {
                return (
                  <td key={id}>
                    <div className="d-flex justify-content-between align-items-center">
                      <span>{label}</span>
                    </div>
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            <tr className="sticky">
              <td className="index"></td>
              {DisplayFields?.map(({ search_fields }, index) => {
                const search_field = search_fields?.[0];

                if (!search_field) {
                  return null;
                }
                const {
                  field,
                  label,
                  isSelect,
                  isRegexSearching,
                  searchedField,
                } = search_field;

                return (
                  <th
                    key={index}
                    className="header-cell search"
                    style={{ width: "400px" }}
                  >
                    {/* {functions.renderInput(
                      field,
                      () => {},
                      {},
                      "",
                      () => {},
                      label,
                      isSelect,
                      isRegexSearching,
                      false,
                      false,
                      lang,
                      searchedField
                    )} */}

                    {/* {
        "label": "ghichu-$15GC",
        "value": "ghichu",
        "field": {
            "id": 21709,
            "field_name": "Ghi Chú",
            "fomular_alias": "15GC",
            "create_by": {
                "username": "administrator",
                "fullname": "Administrator"
            },
            "create_at": "2024-03-25T08:54:01.683Z",
            "props": {
                "DATATYPE": "TEXT",
                "NULL": true,
                "LENGTH": 65535,
                "AUTO_INCREMENT": true,
                "full_text_search": false,
                "_index": false,
                "DEFAULT_TRUE": "TRUE",
                "DEFAULT_FALSE": "FALSE",
                "FILE_MAX_SIZE": "10",
                "FILE_MULTIPLE": false,
                "FILE_ACCEPT_TYPES": [
                    "png",
                    "jpg",
                    "jpeg"
                ]
            },
            "field_alias": "15GC",
            "table_id": 21706,
            "DATATYPE": "TEXT",
            "NULL": true,
            "LENGTH": 65535,
            "AUTO_INCREMENT": true,
            "full_text_search": false,
            "_index": false,
            "DEFAULT_TRUE": "TRUE",
            "DEFAULT_FALSE": "FALSE",
            "FILE_MAX_SIZE": "10",
            "FILE_MULTIPLE": false,
            "FILE_ACCEPT_TYPES": [
                "png",
                "jpg",
                "jpeg"
            ]
        },
        "isRegexSearching": true
    }
] */}
                    <RenderInput
                      field={field}
                      onChange={(value) => {
                        console.log("ON CHANGE", value, search_field);

                        setSearchingData();
                      }}
                    />
                  </th>
                );
              })}
            </tr>

            {data.map((item, index) => {
              return (
                <tr key={index}>
                  <td className="index">{index + 1}</td>
                  {DisplayFields?.map(({ value = [] }, index) => {
                    const content = [];

                    for (const index in value) {
                      const { value: formula_alias, alias } = value[index];
                      if (item[formula_alias]) {
                        content.push(<p>{item[formula_alias]}</p>);
                      } else if (item[alias]) {
                        if (Array.isArray(item[alias])) {
                          const array = item[alias];

                          for (const k in array) {
                            const _item = array[k];
                            if (_item[formula_alias]) {
                              content.push(<p>{_item[formula_alias]}</p>);
                            }
                          }
                        }
                      } else {
                      }
                    }

                    return (
                      <td
                        key={index}
                        className="header-cell search"
                        style={{ width: "400px" }}
                      >
                        {content}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </section>
    </section>
  );
};
